module.exports = __webpack_public_path__ + "img/icon-kuran-default.1c5b2093.jpg";